
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Home } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import JourneyHeader from "@/components/JourneyHeader";
import axios from 'axios';
import { API_BASE_URL } from "@/config";

const SuccessWhitespace = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [loanAmount, setLoanAmount] = useState<number>(0);

  useEffect(() => {
    const fetchLoanAmount = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/get_whitespace_loan_amount/`);
        setLoanAmount(response.data.loan_amount || 0);
      } catch (error) {
        console.error("Error fetching loan amount:", error);
      }
    };
    fetchLoanAmount();
  }, []);

  const handleExit = async () => {
    await logout();
    navigate('/');
  };

  const xLakhs = Math.max(5, Math.ceil(loanAmount / 500000) * 5);

  return (
    <div className="min-h-screen bg-intellend-white">
      <JourneyHeader />

      <div className="container mx-auto px-4 py-8 flex justify-center items-center min-h-[calc(100vh-100px)]">
        <Card className="w-full max-w-md shadow-lg border-t-4 border-t-intellend-green">
          <CardHeader className="flex flex-col items-center pb-2">
            <div className="bg-green-100 p-3 rounded-full mb-4">
              <CheckCircle2 className="h-12 w-12 text-intellend-green" />
            </div>
            <CardTitle className="text-2xl text-center text-intellend-green">
              Submission Successful
            </CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4 pt-2">
            <p className="text-gray-600 text-lg leading-relaxed">
              Many thanks for your inputs. Intellend team is working to get loans upto {xLakhs} lakhs for you and will soon get in touch.
            </p>
            {/* <p className="text-gray-700 text-base font-medium leading-relaxed mt-2">
              Thanks for your inputs, the team is working to get you loans upto ₹35 Lakhs and more based on your data.
            </p> */}

            <div className="flex justify-center mt-6 pt-4 border-t border-gray-100">
              <Button
                onClick={handleExit}
                className="flex items-center gap-2 w-full md:w-auto"
                variant="default"
              >
                <Home size={18} />
                Exit to Home
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SuccessWhitespace;
